import makePage from 'modules/makePage';
import { ProjectAreaQueries } from '../useProjectAreaQueries';
import ProjectStopesPage from './ProjectStopesPage/ProjectStopesPage';

export default makePage<any, [], ProjectAreaQueries>({
  WrappedPage: ProjectStopesPage,
  inheritParent: true,
});
